import { useContext } from "react";
import { AppContext } from "../contexts";
import { renderFormattedAppointmentDate } from "../utils";
import useTranslation from "./useTranslation";
import useDateTime from "./useDateTime";
function useAppointmentDetails(startTimeInUTC, endTimeInUTC, overrides = {}) {
  const { i18n } = useTranslation();
  const { formattedTime, formattedDate } = useDateTime();
  const { appointmentData } = useContext(AppContext);
  const { service } = appointmentData;
  const confirmationNumber = overrides.confirmationNumber || appointmentData.confirmationNumber;
  const address = overrides.address || appointmentData.address;
  const confirmationItem = { title: i18n('cp_confirmation_number'), copy: confirmationNumber };

  // Task pages lead with the task name; appointment pages lead with the confirmation number
  const leadItems = overrides.task
    ? [{ title: i18n('cp_task'), copy: overrides.task }, confirmationItem]
    : [confirmationItem, { title: i18n('cp_service'), copy: service }];

  return [
    ...leadItems,
    { title: i18n('cp_address'), copy: address },
    { title: i18n('cp_appointment_date_time'), copy: renderFormattedAppointmentDate(startTimeInUTC, endTimeInUTC, formattedTime, formattedDate) },
    { title: i18n('cp_subcontractor'), copy: overrides.subcontractor },
    { title: i18n('cp_technician'), copy: overrides.technician },
  ].filter(x => !!x.copy);
}

export default useAppointmentDetails;
